import { oxford } from 'humanize-plus'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import { getUserDisplayName } from 'app/modules/user/utils'
import RuleLink from 'components/conversation/RuleLink'
import PlaybookConversationEvent from 'components/conversation/PlaybookConversationEvent'
import { Link } from 'react-router'

export function showParticipantsNotification(
  currentUser,
  authorUserId,
  participantIds,
  userProperties,
  hasCentralizedRouting = false,
) {
  if (hasCentralizedRouting) {
    if (userProperties.get('notifications-snoozed')) {
      return false
    }
  } else {
    if (currentUser.availability === 'OFFLINE') {
      return false
    }
  }

  return (
    userProperties.get('humane-notifications-browser', 'nothing') !== 'nothing' &&
    currentUser.id !== authorUserId &&
    participantIds.includes(currentUser.id)
  )
}

export function formatParticipantsEvent(
  authorUserId,
  firstChatMessage,
  playbook,
  conversationEvent,
  currentUserId,
  isCurrentUserAdmin,
  usersById,
  added,
  hasCentralizedRouting,
) {
  const { participantIds, participantChangeType } = conversationEvent
  const attributes = firstChatMessage && firstChatMessage.attributes

  if (participantIds.includes(authorUserId)) {
    const others = getOthers(participantIds, usersById, { filterUser: authorUserId })

    if (added) {
      return others.length > 0
        ? `joined the conversation, and invited ${others}`
        : 'joined the conversation'
    } else {
      return others.length > 0
        ? `left the conversation, along with ${others}`
        : 'left the conversation'
    }
  }

  if (participantChangeType === 'MANUAL') {
    if (authorUserId === 0) {
      const others = getOthers(participantIds, usersById, { skipFirst: true })

      if (added) {
        return others.length > 0
          ? `joined the conversation, along with ${others}`
          : 'joined the conversation'
      } else {
        return others.length > 0
          ? `left the conversation, along with ${others}`
          : 'left the conversation'
      }
    }

    return `${added ? 'invited' : 'removed'} ${getOthers(participantIds, usersById)} ${added
      ? 'to'
      : 'from'} the conversation`
  }

  if (participantChangeType === 'ON_CALL') {
    return `joined the conversation from ${hasCentralizedRouting ? 'the Default Lead Routing Rule' : 'being On-Call'}`
  }

  if (participantChangeType === 'PLAYBOOK_GOAL' && isCurrentUserAdmin) {
    return <PlaybookConversationEvent {...conversationEvent} />
  }

  if (participantChangeType === 'ROUTING_RULE') {
    const others = getOthers(participantIds, usersById, { skipFirst: true })

    if (others.length > 0) {
      return (
        <span>
          joined conversation from Lead Routing Rule <RuleLink ruleId={conversationEvent.ruleId} />,
          along with {others}
        </span>
      )
    }

    return (
      <span>
        joined conversation from Lead Routing Rule <RuleLink ruleId={conversationEvent.ruleId} />
      </span>
    )
  }

  if (participantChangeType === 'DIRECT') {
    // check params set in attributes of first message
    // to deduce precise route
    if (attributes) {
      if (attributes.get("profileMode")) {
        return 'added to the conversation that was started from their Drift Profile'
      }
      if (attributes.get("liveViewInitiated")) {
        return 'joined the conversation from Live View'
      }
    }
    // check whether playbook type contains "ABM" or "OUTBOUND" strings
    const reportType = playbook.get("reportType")
    if(reportType) {
      if(reportType.indexOf("ABM") >= 0) {
        return "joined the conversation from ABM routing"
      }
      if(reportType.indexOf("OUTBOUND") >= 0) {
        return "joined the conversation from an Outbound Email"
      }
    }
    // if nothing matches, return the generic string
    return 'joined the conversation from a Direct Message'
  }

  if (participantChangeType === "PLAYBOOK_ACTION"){
    return (
      <span>
          joined conversation from Playbook <Link href={`/playbooks/editor/${playbook.id}/`}>{playbook.name}</Link>
          and Route Conversation skill
      </span>
      )
  }

  return `${added ? 'added' : 'removed'} ${getOthers(participantIds, usersById)} ${added
    ? 'to'
    : 'from'} conversation`
}

export function formatParticipantsNotification(
  authorUserId,
  conversationEvent,
  usersById,
  endUser,
  added
) {
  const { participantChangeType } = conversationEvent

  if (participantChangeType === 'ON_CALL') {
    return `You’ve been added to the conversation with ${getDisplayName(endUser)}`
  }

  if (participantChangeType === 'ROUTING_RULE') {
    return `The conversation with ${getDisplayName(endUser)} has been routed to you`
  }

  if (participantChangeType === 'DIRECT') {
    return `You’ve been added to the conversation with ${getDisplayName(
      endUser
    )} from a Direct Message`
  }

  if (participantChangeType === 'PLAYBOOK_GOAL') {
    return `You’ve been added to the conversation with ${getDisplayName(
      endUser
    )} from a Playbook Goal`
  }

  const author = getUserDisplayName(usersById[authorUserId])
  return `${author} ${added ? 'added' : 'removed'} you ${added
    ? 'to'
    : 'from'} the conversation with ${getDisplayName(endUser)}`
}

function getOthers(participantIds, usersById, options = {}) {
  let others = participantIds
  const { filterUser, skipFirst } = options

  if (filterUser) {
    others = participantIds.filter(id => id !== filterUser)
  }

  if (skipFirst) {
    others = participantIds.slice(1)
  }

  return oxford(
    others
      .map(id => usersById.get(id))
      .map(getUserDisplayName)
      .filter(Boolean),
    5
  )
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/participants/utils.js